import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Navbar, Nav} from 'react-bootstrap';
import { Link } from 'react-router-dom';

import { $t } from '../../utils/translate';
import { getMessages } from '../../actions/messageActions';

class HistoryBar extends Component {
    constructor(props) {
        super(props);
        this.props = props;
    }

    render() {
        return (
            <div>
                <div className="betbar mx-auto betbar-history">
                    <div className="nav-class nav-betbar-history">
                        <Navbar bg="default" variant="dark">
                            <Nav className="mr-auto w-100">
                                {this.props.open !== "draw" &&
                                    <Link className={this.props.open == "true" ? "active-link history-bar-btn" : " history-bar-btn "} to={{ ...location, pathname: "/bet-history" }}><span>{$t('section_open_bets', 'default', this.props.messages)}</span></Link>
                                }
                                {this.props.open !== "draw" &&
                                    <Link className={this.props.open == "false" ? "active-link history-bar-btn" : " history-bar-btn "} to={{ ...location, pathname: "/bet-settled-history" }}><span>{$t('section_settled_bets', 'default', this.props.messages)}</span></Link>
                                }
                            </Nav>
                        </Navbar>
                    </div>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
      messages: state.messageReducer.messages
    }
}

export default connect(mapStateToProps,{getMessages})(HistoryBar);



// WEBPACK FOOTER //
// ./components/HistoryBar/index.js